import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Ghost, Github, Menu, X } from 'lucide-react';
import { useState } from 'react';

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isDocsPage = location.pathname.startsWith('/docs') || location.pathname === '/playground';

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/[0.06]" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <div className="w-8 h-8 rounded-md bg-white flex items-center justify-center group-hover:scale-105 transition-transform">
            <Ghost className="w-5 h-5 text-black" />
          </div>
          <span className="font-bold text-sm tracking-tight">GhostLayout</span>
          <span className="text-[10px] font-mono text-white/30 border border-white/10 px-1.5 py-0.5 rounded">v1.0</span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1" data-testid="desktop-nav">
          <Link
            to="/docs"
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${isDocsPage ? 'text-white bg-white/[0.08]' : 'text-white/50 hover:text-white'}`}
            data-testid="nav-docs"
          >
            Docs
          </Link>
          <Link
            to="/playground"
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${location.pathname === '/playground' ? 'text-white bg-white/[0.08]' : 'text-white/50 hover:text-white'}`}
            data-testid="nav-playground"
          >
            Playground
          </Link>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="px-3 py-1.5 text-white/50 hover:text-white transition-colors"
            data-testid="nav-github"
          >
            <Github className="w-5 h-5" />
          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          className="md:hidden text-white/60 hover:text-white"
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-btn"
        >
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile nav */}
      {mobileOpen && (
        <div className="md:hidden border-t border-white/[0.06] bg-black/95 backdrop-blur-xl px-6 py-4 space-y-2">
          <Link to="/docs" className="block py-2 text-sm text-white/60 hover:text-white" onClick={() => setMobileOpen(false)}>Docs</Link>
          <Link to="/playground" className="block py-2 text-sm text-white/60 hover:text-white" onClick={() => setMobileOpen(false)}>Playground</Link>
        </div>
      )}
    </header>
  );
}
